import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Spinner, Alert } from "react-bootstrap";
import API from "../../api/api";

export default function RequestWithdrawModal({ show, handleClose, onSuccess }) {
  const [amount, setAmount] = useState("");
  const [balance, setBalance] = useState(0);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loadingBalance, setLoadingBalance] = useState(false);

  // Fetch available balance when modal opens
  useEffect(() => {
    const fetchBalance = async () => {
      try {
        setLoadingBalance(true);
        const res = await API.get("/api/encashments/wallet", {
          withCredentials: true,
        });
        if (res.data.success) {
          setBalance(res.data.balance || 0);
        }
      } catch (err) {
        console.error("Error fetching balance:", err);
        setError("Could not fetch balance.");
      } finally {
        setLoadingBalance(false);
      }
    };

    if (show) {
      setAmount("");
      setError("");
      setSuccess("");
      fetchBalance();
    }
  }, [show]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    if (Number(amount) > balance) {
      setError("You cannot withdraw more than your available balance.");
      setLoading(false);
      return;
    }

    try {
      const res = await API.post(
        "/api/encashments",
        { amount },
        { withCredentials: true }
      );

      if (res.data.success) {
        setSuccess("Withdraw request submitted successfully.");
        onSuccess();
        setTimeout(() => {
          handleClose();
        }, 800);
      }
    } catch (err) {
      setError(err.response?.data?.error || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Request Withdraw</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {error && <Alert variant="danger">{error}</Alert>}
          {success && <Alert variant="success">{success}</Alert>}

          {loadingBalance ? (
            <div className="text-center my-2">
              <Spinner animation="border" size="sm" /> Loading balance...
            </div>
          ) : (
            <div className="alert alert-info">
              <strong>Available Balance:</strong> Rs. {balance}
            </div>
          )}

          <Form.Group>
            <Form.Label>Amount (Rs.)</Form.Label>
            <Form.Control
              type="number"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="Enter amount"
              required
              min="1"
              max={balance}
            />
          </Form.Group>
          <div className="text-end">
            <br />
            <Button
              type="submit"
              variant="success"
              disabled={loading || balance === 0}
            >
              {loading ? "Submitting..." : "Submit"}
            </Button>
          </div>
        </Modal.Body>
      </Form>
    </Modal>
  );
}



// import React, { useEffect, useState } from "react";
// import { Modal, Button, Form, Spinner } from "react-bootstrap";
// import API from "../../api/api";

// export default function RequestWithdrawModal({ show, handleClose, onSuccess }) {
//   const [amount, setAmount] = useState("");
//   const [balance, setBalance] = useState(0);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState("");
//   const [loadingBalance, setLoadingBalance] = useState(false);

//   // Fetch available balance when modal opens
//   useEffect(() => {
//     const fetchBalance = async () => {
//       try {
//         setLoadingBalance(true);
//         const res = await API.get("/api/earnings/balance", {
//           withCredentials: true,
//         });
//         if (res.data.success) {
//           setBalance(res.data.balance);
//         }
//       } catch (err) {
//         console.error("Error fetching balance:", err);
//       } finally {
//         setLoadingBalance(false);
//       }
//     };

//     if (show) fetchBalance();
//   }, [show]);

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError("");

//     if (Number(amount) > balance) {
//       setError("You cannot withdraw more than your active balance.");
//       setLoading(false);
//       return;
//     }

//     try {
//       const res = await API.post(
//         "/api/encashments",
//         { amount },
//         { withCredentials: true }
//       );

//       if (res.data.success) {
//         onSuccess();
//         handleClose();
//         setAmount("");
//       }
//     } catch (err) {
//       setError(err.response?.data?.error || "Something went wrong");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Modal show={show} onHide={handleClose} centered>
//       <Form onSubmit={handleSubmit}>
//         <Modal.Header closeButton>
//           <Modal.Title>Request Withdraw</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {error && <div className="alert alert-danger">{error}</div>}

//           {loadingBalance ? (
//             <div className="text-center my-2">
//               <Spinner animation="border" size="sm" /> Loading balance...
//             </div>
//           ) : (
//             <div className="alert alert-info">
//               <strong>Available Balance:</strong> Rs. {balance}
//             </div>
//           )}

//           <Form.Group>
//             <Form.Label>Amount (Rs.)</Form.Label>
//             <Form.Control
//               type="number"
//               value={amount}
//               onChange={(e) => setAmount(e.target.value)}
//               placeholder="Enter amount"
//               required
//               min="1"
//               max={balance}
//             />
//           </Form.Group>
//           <div className="text-end">
//             <br />
//             <Button
//               type="submit"
//               variant="success"
//               disabled={loading || balance === 0}
//             >
//               {loading ? "Submitting..." : "Submit"}
//             </Button>
//           </div>
//         </Modal.Body>
        
//       </Form>
//     </Modal>
//   );
// }
